import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface HomePageSectionContainerStyles {
    container?: InjectableCss;
    qtyWrapper?: InjectableCss;
    uomWrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    wishlistWrapper?: InjectableCss;
}

const styles: HomePageSectionContainerStyles = {
    container: {
        css: css`
            display: flex;
            background: #f2f3f5;
            padding: 10px;
            flex-wrap: wrap;
            justify-content: space-between;
        `,
    },
    qtyWrapper: {
        css: css`
            flex-basis: 49%;
            margin-bottom: 10px;
        `,
    },
    uomWrapper: {
        css: css`
            flex-basis: 49%;
            margin-bottom: 10px;
        `,
    },
    addToCartWrapper: {
        css: css`
            flex-basis: 100%;
            div[class^="FormFieldStyle"] {
                background: none;
                > label {
                    border: 1px solid rgb(217, 217, 217);
                    margin: 6px 0px;
                    flex-basis: 32%;
                    -webkit-box-pack: center;
                    justify-content: center;
                    background: rgb(255, 255, 255);
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    border-right: none;
                    padding: 4px 4px 5px;
                    border-image: initial;
                    font-size: 16px;
                }
                div[class^="FormInputWrapper"] {
                    max-width: 100%;
                    flex-basis: 100%;
                    & input {
                        margin: 0px 10px 10px 0px;
                        height: 40px;
                        border-radius: 0px !important;
                    }
                    > select {
                        margin: 6px 0px;
                        padding: 0 10px;
                    }
                    > span[class^="IconWrapper"] {
                        top: 6px;
                        width: 40px;
                    }
                }
            }
        `,
    },
    wishlistWrapper: {
        css: css`
            flex-basis: 100%;
            display: flex;
            & svg {
                color: #a8a8a8;
            }
            & button {
                &:hover,
                &:focus {
                    svg {
                        fill: #59b46c;
                    }
                    &:hover {
                        background: #69a342;
                        border: 2px solid #69a342;
                        span {
                            color: #ffffff !important;
                        }
                    }
                    outline: none;
                }
                cursor: pointer;
                font-family: inherit;
                height: 40px;
                line-height: 1;
                background: transparent;
                border: 2px solid #91a1a3;
                color: #363636;
                width: 100%;
                padding: 0 12px 0 12px;
                text-transform: uppercase;
                margin: 0;
                display: flex;
                justify-content: center;
                span {
                    color: #91a2a4 !important;
                    font-weight: 700;
                }
            }
        `,
    },
};

export const HomePageSectionContainerStyles = styles;

const HomePageSectionContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.qtyWrapper}>
                <Zone contentId={id} zoneName="qty" />
            </StyledWrapper>
            <StyledWrapper {...styles.uomWrapper}>
                <Zone contentId={id} zoneName="uom" />
            </StyledWrapper>
            <StyledWrapper {...styles.addToCartWrapper}>
                <Zone contentId={id} zoneName="addToCart" />
            </StyledWrapper>
            <StyledWrapper {...styles.wishlistWrapper}>
                <Zone contentId={id} zoneName="addToWishList" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const homePageSectionContainer: WidgetModule = {
    component: HomePageSectionContainer,
    definition: {
        group: "Common",
    },
};

export default homePageSectionContainer;
